
export {DataProvider,
FetchPolicy,
NetworkStatus,
useResource} from '@clayui/data-provider';
import __x__ from '@clayui/data-provider';export default __x__;